/**
 * Het inlogscherm, voor alle drie de rollen.
 */
import React, { useState } from 'react';
import { inloggen } from '../api/client';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await inloggen(username, password);
      onLogin(data.user, data.token);
    } catch (err) {
      // met status: de server zei nee (fout wachtwoord); zonder: geen verbinding
      setError(err.status ? err.message : 'Kan geen verbinding maken met de server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <img
            src="/Anna_Maria.png"
            alt="Anna Maria"
            style={styles.image}
          />
          <p style={styles.subtitle}>Teksten leren lezen</p>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Gebruikersnaam"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
            onFocus={(e) => e.target.style.border = '2px solid black'}
            onBlur={(e) => e.target.style.border = username ? '2px solid black' : '2px solid var(--lijn)'}
            required
          />
          <input
            type="password"
            placeholder="Wachtwoord"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            onFocus={(e) => e.target.style.border = '2px solid black'}
            onBlur={(e) => e.target.style.border = password ? '2px solid black' : '2px solid var(--lijn)'}
            required
          />
          {error && <p style={styles.error}>{error}</p>}

          <button
            type="submit"
            style={styles.button}
            disabled={loading}
          >
            {loading ? 'Bezig...' : 'Inloggen'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--wit)',
    padding: '20px',
  },
  card: {
    background: 'var(--wit)',
    padding: '40px',
    width: '100%',
    maxWidth: '450px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  image: {
    width: '100%',
    maxWidth: '350px',
    height: 'auto',
    marginBottom: '16px',
    borderRadius: '8px',
  },
  subtitle: {
    color: 'var(--stil)',
    fontSize: '18px',
  },
  input: {
    width: '100%',
    padding: '14px',
    border: '2px solid var(--lijn)',
    borderRadius: '8px',
    fontSize: '16px',
    marginBottom: '16px',
    outline: 'none',
    transition: 'border-color 0.2s',
    backgroundColor: 'var(--wit)',
    WebkitBoxShadow: '0 0 0 1000px white inset',
    WebkitTextFillColor: 'black',
  },
  button: {
    width: '100%',
    padding: '14px',
    background: 'var(--accent)',
    color: 'var(--wit)',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  error: {
    color: 'var(--fout-2)',
    marginBottom: '16px',
    textAlign: 'center',
  },
};

export default Login;
